var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17C34 25.4854 27.783 32.5185 19.6562 33.7935V21.9141H23.6174L24.3711 17H19.6562V13.8112C19.6562 12.4664 20.315 11.1562 22.4267 11.1562H24.5703V6.97266C24.5703 6.97266 22.6246 6.64062 20.7646 6.64062C16.8818 6.64062 14.3438 8.99406 14.3438 13.2547V17H10.0273V21.9141H14.3438V33.7935C6.21695 32.5185 0 25.4854 0 17C0 7.61148 7.61148 0 17 0C26.3885 0 34 7.61148 34 17Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6174 21.9141L24.3711 17H19.6562V13.8111C19.6562 12.4667 20.3149 11.1562 22.4267 11.1562H24.5703V6.97266C24.5703 6.97266 22.6249 6.64062 20.7649 6.64062C16.8817 6.64062 14.3438 8.99406 14.3438 13.2547V17H10.0273V21.9141H14.3438V33.7934C15.2093 33.9292 16.0963 34 17 34C17.9037 34 18.7907 33.9292 19.6562 33.7934V21.9141H23.6174Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook_logo.486ce4f50939d79c68314a82fa8341a1.svg";
export { ForwardRef as ReactComponent };